import React, { useState } from 'react';
import {
    Button,
    IconButton,
    Typography,
    Box,
    Modal,
    Avatar,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};

const AllNotes = ({ open, onClose }) => {

    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm" >
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>

                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily:'Manrope' }}>All notes</Typography>

                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ margin: '0 auto 16px' }}>
                        <Box display="flex" alignItems="center" sx={{ gap: '8px' }}>
                            <Avatar sx={{ height: '32px', width: '32px', fontSize: '14px', backgroundColor: '#5932EA', color: '#fff', fontFamily:'Manrope' }}>
                                {/* <span>SG</span> */}
                                <img src="./assets/images/insights/notification/custome-notification-img.png" style={{
                                    height: '32px', width: '32px',
                                    backgroundSize: 'cover', objectFit: 'cover'
                                }} alt='project icon' className="img-fluid" />
                            </Avatar>
                            <Box>
                                <Typography fontSize={'16px'} fontWeight={'600'} sx={{ lineHeight: '1', color: '#1A1F36', fontFamily:'Manrope' }}>Vansh Saini’s Notes </Typography>
                            </Box>
                        </Box>
                        <Box display="flex" alignItems="center" sx={{ gap: '8px' }}>
                            <Typography fontSize={'16px'} fontWeight={'600'} sx={{ lineHeight: '1', color: '#1A1F36', fontFamily:'Manrope' }}>Date:</Typography>
                            <Typography fontSize={'16px'} fontWeight={'400'} sx={{ lineHeight: '1', color: '#8C8C8C', fontFamily:'Manrope' }}>30 April 2025</Typography>
                        </Box>
                    </Box>

                    <Box>
                        <Box display="flex" alignItems="center" sx={{ gap: '8px' }}>
                            <Avatar sx={{ height: '42px', width: '42px', fontSize: '14px', backgroundColor: '#5932EA', color: '#fff', fontFamily:'Manrope' }}>
                                <span>SG</span>
                                {/* <img src="./assets/images/insights/file/project-icon.svg" alt='project icon' className="img-fluid" style={{
                                    height: '32px', width: '32px',
                                    backgroundSize: 'cover', objectFit: 'cover' /> */}
                            </Avatar>
                            <Box>
                                <Typography fontSize={'16px'} fontWeight={'600'} sx={{ lineHeight: '1', color: '#1A1F36', fontFamily:'Manrope' }}>Sky Grid</Typography>
                                <Typography fontSize={'12px'} color='#64748B' fontWeight={'400'} sx={{fontFamily:'Manrope', margin:'4px auto'}}>Wed, Apr 30, 2025 | 9:44 am - 10:46 am</Typography>
                            </Box>
                        </Box>
                        <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#373737', fontFamily:'Manrope', margin:'8px auto 0' }}>working on the mobile application</Typography>
                    </Box>

                    <Box sx={{ margin: '24px auto 0' }}>
                        <Box display="flex" alignItems="center" sx={{ gap: '8px' }}>
                            <Avatar sx={{ height: '42px', width: '42px', fontSize: '14px', backgroundColor: '#FF8328', color: '#fff', fontFamily:'Manrope' }}>
                                <span>CB</span>
                                {/* <img src="./assets/images/insights/file/project-icon.svg" alt='project icon' className="img-fluid" /> */}
                            </Avatar>
                            <Box>
                                <Typography fontSize={'16px'} fontWeight={'600'} sx={{ lineHeight: '1', color: '#1A1F36', fontFamily:'Manrope' }}>Creative Boost</Typography>
                                <Typography fontSize={'14px'} color='#64748B' fontWeight={'400'} sx={{fontFamily:'Manrope', margin:'4px auto'}}>Wed, Apr 30, 2025 | 9:44 am - 10:46 am</Typography>
                            </Box>
                        </Box>
                        <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#373737', fontFamily:'Manrope', margin:'8px auto 0' }}>Hubstaff timer got paused automatically. Just came from lunch and noticed that there's no pop up. Upon checking, came to know that the timer was stopped.</Typography>
                    </Box>

                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'end', gap: 2, borderRadius: '0 0 12px 12px', borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily:'Manrope' }}>
                        Close
                    </Button>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default AllNotes;
